module.exports = __webpack_public_path__ + "static/media/estrella.45dd5470.png";